import React from 'react';
import PropTypes from 'prop-types';
import GeckoRequest from 'services/gecko-request';
import GeckoLocation from 'services/gecko-location';
import {
  GECKO_CONSTS,
  GeckoFormField,
  GeckoForm,
  GeckoModal,
  GeckoModalService,
  GeckoToastService,
} from 'ui';
import { renderError } from 'services/gecko-error';

const EditDataModal = ({
  dataSourceId,
  rowData = {},
  onSave = () => {},
  ...props
}) => {
  const submit = (rowData) => {
    const url = `/datasource/${dataSourceId}/${rowData.id}`;

    const payload = Object.assign({}, rowData);
    delete payload.id;

    return GeckoRequest.post(url, payload)
      .then((dataSource) => {
        new GeckoToastService().success('Your changes have been saved.');
        GeckoLocation.reload();

        onSave(dataSource);
        return new GeckoModalService().close();
      })
      .catch(renderError);
  };

  return (
    <GeckoForm initialValues={rowData} onSubmit={submit}>
      {({ values, handleSubmit, errors }) => (
        <GeckoModal
          name={'Edit Row Data'}
          btns={[
            {
              type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
              name: 'Done',
              icon: 'far fa-check',
              handler: handleSubmit,
            },
          ]}
        >
          <div className="DataSourceForm">
            {Object.entries(rowData).map(([key, value]) => {
              if (key === 'id') {
                return null;
              }
              return (
                <GeckoFormField
                  fieldType="text"
                  name={key}
                  label={key}
                  placeholder={key}
                />
              );
            })}
          </div>
        </GeckoModal>
      )}
    </GeckoForm>
  );
};

EditDataModal.propTypes = {
  dataSourceId: PropTypes.string,
  onSave: PropTypes.func,
  rowData: PropTypes.object,
};

export default EditDataModal;
